import { render } from "./RocketSection.vue?vue&type=template&id=07aa4fe8&scoped=true"
import script from "./RocketSection.vue?vue&type=script&lang=js"
export * from "./RocketSection.vue?vue&type=script&lang=js"

import "./RocketSection.vue?vue&type=style&index=0&id=07aa4fe8&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07aa4fe8"]])

export default __exports__